import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bbafd26"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "rootContainer chatbotMode",
  id: "rootContainer"
}
const _hoisted_2 = { key: 3 }
const _hoisted_3 = {
  key: 4,
  class: "loadingError"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_Close = _resolveComponent("Close")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    (
			(_ctx.company.isQuizClosed && _ctx.quizIsProperlyLoaded) ||
			_ctx.$route.name === 'CompanySelection'
		)
      ? (_openBlock(), _createBlock(_component_RouterView, {
          key: 0,
          company: _ctx.company,
          snippetCompanyCode: _ctx.companyCode
        }, null, 8, ["company", "snippetCompanyCode"]))
      : (_ctx.quizIsProperlyLoaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (
				(!_ctx.company.isQuizClosed &&
					!_ctx.company.homepageMode &&
					(_ctx.company.isSavedSessionLoaded ||
						(_ctx.company.Quiz.getCurrentQuestion &&
							_ctx.company.Quiz.getCurrentQuestion().FrontendSettings &&
							_ctx.company.Quiz.getCurrentQuestion().FrontendSettings.find(
								(el) => el.Key === 'showNavBar'
							)?.Value !== 'false')))
			)
              ? (_openBlock(), _createBlock(_component_HeaderComponent, {
                  key: 0,
                  company: (_ctx.company as Company),
                  class: "header",
                  id: "header"
                }, null, 8, ["company"]))
              : _createCommentVNode("", true),
            (
				!_ctx.company.isQuizClosed
				&& !_ctx.isFeatureModeBlocked
			)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "quizCloseButton",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleQuizClose && _ctx.handleQuizClose(...args)))
                }, [
                  _createVNode(_component_Close)
                ]))
              : _createCommentVNode("", true),
            (_ctx.quizIsProperlyLoaded)
              ? (_openBlock(), _createBlock(_component_RouterView, {
                  key: 2,
                  company: _ctx.company
                }, null, 8, ["company"]))
              : (!_ctx.loadingError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_Loading, { class: "loading" })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("h2", null, [
                      _createTextVNode(_toDisplayString(_ctx.company.DisplayedTexts["Beim laden des Quizzes ist ein Fehler aufgetreten."]) + " ", 1),
                      _hoisted_4,
                      _createTextVNode(" " + _toDisplayString(_ctx.company.DisplayedTexts["Bitte versuche es erneut."]), 1)
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.reloadQuiz && _ctx.reloadQuiz(...args)))
                    }, "Neu laden")
                  ])),
            (!_ctx.company.isQuizClosed || _ctx.quizIsProperlyLoaded)
              ? (_openBlock(), _createBlock(_component_FooterComponent, {
                  key: 5,
                  class: "footer",
                  company: (_ctx.company as Company)
                }, null, 8, ["company"]))
              : _createCommentVNode("", true),
            (
				_ctx.company.CompanyQuizConfig.ShowRestartButton &&
				_ctx.company.Quiz.QuestionIdHistory.length > 1 &&
				!_ctx.company.isQuizClosed
			)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 6,
                  class: "restartButton",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.company.restartQuiz()))
                }, _toDisplayString(_ctx.company.DisplayedTexts["Quiz Neustarten"]), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
  ]))
}